var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-field-like',{attrs:{"value":_vm.viewValue,"label":_vm.label,"placeholder":_vm.placeholder,"flat":_vm.flat,"hide-details":_vm.hideDetails,"loading":_vm.loading,"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }